<template>
  <SharedError
    :description="description || $i18n.t('common.errors.403.description')"
    :title="title || $i18n.t('common.errors.403.title')"
    :url="showHomeButton ? url : undefined"
    :show-logout-button="showLogoutButton"
    :show-home-button="showHomeButton"
    :need-to-reload-page="needToReloadPage"
  />
</template>
<script lang="ts" setup>
interface Props {
  description?: string;
  title?: string;
  url?: string;
  showLogoutButton?: boolean;
  needToReloadPage?: boolean;
  showHomeButton?: boolean;
}
const { $i18n } = useNuxtApp();

const props = withDefaults(defineProps<Props>(), {
  url: "/",
  showLogoutButton: false,
  needToReloadPage: true,
  showHomeButton: true,
});

const { description, title, showLogoutButton, showHomeButton, needToReloadPage } = toRefs(props);
</script>
